<template>
  <div class="student-chapter-statistics-page">
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/studentList' }">在读学员</el-breadcrumb-item>
      <el-breadcrumb-item>章节训练统计</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <div slot="header" class="card-header">
        <span>学生：{{ realname }} - 章节训练统计记录</span>

        <!-- 按钮组：靠右 + 顺序：返回 → 训练记录 -->
        <div class="header-btns">
          <el-button icon="el-icon-back" @click="back" size="mini">返回</el-button>
          <el-button type="warning" @click="goChallengePage" size="mini">训练记录</el-button>
        </div>
      </div>

      <!-- 查询条件 -->
      <el-form :model="queryParam" inline>
        <el-form-item label="学科">
          <el-select v-model="queryParam.subjectId" clearable placeholder="请选择学科" @change="changeSubject">
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadData">查询</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格：去掉 max-height 防止竖向滚动条 -->
      <el-table :data="dataList" stripe border :loading="loading">
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="课本" prop="textbookname" align="center" min-width="180"></el-table-column>
        <el-table-column label="章" prop="captername" align="center" min-width="160"></el-table-column>
        <el-table-column label="节" prop="sectionname" align="center" min-width="160"></el-table-column>
        <el-table-column label="正确率" align="center">
          <template slot-scope="scope">
            {{ scope.row.accuracy || 0 }}%
          </template>
        </el-table-column>
        <el-table-column label="训练时长" align="center">
          <template slot-scope="scope">
            {{ formatTime(scope.row.longthoftime) }}
          </template>
        </el-table-column>
        <el-table-column label="训练时间" prop="createtime" align="center" width="180"></el-table-column>

        <!-- 操作列 -->
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              @click="openChapterDetail(scope.row)"
              type="text"
              style="color:#6f7cb2"
            >
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNo"
        :page-size="queryInfo.pageSize"
        :total="total"
        background
        style="text-align:right;margin-top:20px"
      ></el-pagination>
    </el-card>

    <ChapterDetailModal
      :visible.sync="detailModalVisible"
      :studentId="studentId"
      :sectionId="currentSectionId"
    />
  </div>
</template>

<script>
  import ChapterDetailModal from "./ChapterDetailModal.vue";

  export default {
    name: "StudentChapterStatistics",
    components: { ChapterDetailModal },
    data() {
      return {
        phone: "",
        realname: "",
        studentId: "",
        currentSectionId: "",
        queryParam: {
          subjectId: "",
        },

        queryInfo: {
          pageNo: 1,
          pageSize: 10
        },
        subjectList: [
          { id: '1273192918914994177', name: '智能数学' },
          { id: '1273275645626441729', name: '智能语文' },
          { id: '1273275718506668033', name: '智能英语' },
          { id: '1273275829026578434', name: '暑期数学' },
          { id: '1273275894373834753', name: '暑期语文' },
          { id: '1273275970143936514', name: '暑期英语' },
          { id: '1326324137453625345', name: '智能科学' },
          { id: '1419710664753164289', name: '强基数学' },
          { id: '1712821416454488065', name: '智能化学' },
          { id: '1767774338015256578', name: '智能物理' },
          { id: '1807675816020164610', name: '智能生物' },
          { id: '1922850541922295809', name: '强基科学' },
          { id: '1981234561206652929', name: '智能政治' },
          { id: '1997109630638174210', name: '智能历史' },
          { id: '1997893625739161602', name: '智能地理' }
        ],
        loading: false,
        dataList: [],
        total: 0,
        detailModalVisible: false,

        url: {
          list: "/ea/student/student/vipssStudentCapterStatistics",
        }
      };
    },
    created() {
      this.phone = this.$route.query.phone;
      this.realname = this.$route.query.realname;
      if (this.phone) {
        this.loadData();
      }
    },
    methods: {
      // 毫秒 转 00:00:00
      formatTime(ms) {
        if (!ms) return '00:00:00';
        let s = parseInt(ms / 1000);
        let h = parseInt(s / 3600).toString().padStart(2, '0');
        let m = parseInt((s % 3600) / 60).toString().padStart(2, '0');
        let sec = (s % 60).toString().padStart(2, '0');
        return `${h}:${m}:${sec}`;
      },

      async loadData() {
        this.loading = true;
        try {
          let params = {
            phone: this.phone,
            subjectId: this.queryParam.subjectId,
            pageNo: this.queryInfo.pageNo,
            pageSize: this.queryInfo.pageSize
          };

          const { data: res } = await this.$http.post(this.url.list, params);
          console.log("章节统计数据", res);

          if (res.code !== 200) {
            this.$message.error(res.message);
            return;
          }
          this.dataList = res.result.records;
          this.total = res.result.total;
        } finally {
          this.loading = false;
        }
      },

      // ✅ 修复：点击详情永远生效
      openChapterDetail(row) {
        this.studentId = row.studentId;
        this.currentSectionId = row.sectionId;

        // 先关闭，再下一帧打开，解决点击不刷新
        this.detailModalVisible = false;
        this.$nextTick(() => {
          this.detailModalVisible = true;
        });
      },

      goChallengePage() {
        this.$router.push({
          path: '/vipssStudentDetail',
          query: {
            phone: this.phone,
            realname: this.realname,
          }
        })
      },

      handleCurrentChange(page) {
        this.queryInfo.pageNo = page;
        this.loadData();
      },

      back() {
        this.$router.go(-1);
      },
      resetQuery() {
        this.queryParam.subjectId = "";
        this.loadData();
      },
      changeSubject(){
        this.loadData();
      }
    }
  };
</script>

<style lang="less" scoped>
  .student-chapter-statistics-page {
    padding: 10px;
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    font-size: 15px;
  }
  .header-btns {
    display: flex;
    gap: 8px;
  }
</style>
